import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Row, Col, Container, Button, Spinner, Form } from 'react-bootstrap';
import { convertNormaltoTokenAmount, getAccountWaveBalance } from '../components/blockchain functions/BlockchainFunctions';
import { exchangeToken } from "../components/contract functions/Exchange";
import { LoginContext } from "../context/LoginContext";
//icons
import exchange from '../components/assets/icons/exchange-money.svg';
import exchangeSymbol from '../components/assets/icons/exchange.svg';
import waveSymbol from '../components/assets/icons/wave-symbol.png';

const ExchangeToken = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);//Loading bar

  const [loginData, setLoginData] = useContext(LoginContext);

  const handleSubmit = async (event) => {
    event.preventDefault();
    let waveAmount = convertNormaltoTokenAmount(event.target.waveAmount.value);
    console.log(waveAmount);
    let result = await exchangeToken(waveAmount, loginData.phrase);
    if (result) {
      toast.success("Exchange successful");
    }
  };

  return (
    <>
      <div className="page-heading">
        <h2><img style={{height:"3rem"}} src={exchange}/> Buy PANDAS Token</h2>
        <span>Buy pandas token in exchnage of wave tokens.</span>
      </div>
      <hr />

      <div className={loading ? 'parentDisable' : ''} width="100%">
        <br />
        <div className={loading ? 'overlay-box' : 'hide'}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
        <Container>
          <Row>
            <Col md={3}></Col>
            <Col md={6}>
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <Form.Label style={{fontWeight:"500"}}>Enter wave amount</Form.Label>
                  <Form.Control type="number" style={{paddingLeft:"5rem", height:"3rem", fontSize:"2rem", border:"2px solid #aea7a7"}} 
                        min="1" defaultValue="1" step="0.5" max="8" id="waveAmount" required />
                  <img style={{height:"2rem",margin:"-80px 0 0 1rem"}} src={waveSymbol}/>
                </Form.Group>
                <Form.Text>Rate= 0.5 PANDAS/Wave <span class="float-right">Max daily limit to exchange is 8 wave token.</span></Form.Text>
                <br />
                <Row>
                  <Button variant="primary" type="submit" size="lg" style={{ width: '100%',marginTop:"1rem" }}
                    disabled={loginData==null||loginData?.phrase==""}>
                  <img style={{height:"2rem"}} src={exchangeSymbol}/> Exchange</Button>
                </Row>
              </Form>
            </Col>
            <Col md={3}></Col>
          </Row>
          <br/><br/><br/><br/>
        </Container>
      </div>
    </>
  )
}

export default ExchangeToken